import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
import pick from 'lodash.pick';
import moment from 'moment';
import { httpAction } from '@/api/manage';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import IwsUpload from '@comp/upload/IwsUpload';
export default {
  name: 'AssetEquipmentRepairDrawer',
  mixins: [ModalFormMixin, GetSiteIdMixin],
  components: {
    IwsUpload: IwsUpload
  },
  data: function data() {
    return {
      title: '仪器检修表表单',
      tableName: 'ea_asset_equipment_repair',
      form_fields: ['siteId', 'userId', 'assetId', 'modelNum', 'cause', 'faultLevel', 'fee', 'description', 'solution', 'replaceSituation', 'calibrationRes', 'checkRes', 'remark', 'tenantId'],
      form_fields_time: ['failureTime', 'calibrationTime', 'normalTime'],
      validatorRules: {
        userId: {
          rules: [{
            required: true,
            message: '请选择维护人员!'
          }]
        },
        assetId: {
          rules: [{
            required: true,
            message: '请选择仪器！'
          }]
        },
        modelNum: {
          rules: [{
            required: true,
            message: '请输入仪器型号！'
          }]
        },
        failureTime: {
          rules: [{
            required: true,
            message: '请选择故障发生时间!'
          }]
        },
        cause: {
          rules: [{
            required: true,
            message: '请选择故障/异常原因!'
          }]
        },
        description: {
          rules: [{
            required: true,
            message: '请输入检修情况说明！'
          }]
        },
        solution: {
          rules: [{
            required: true,
            message: '请输入解决办法！'
          }]
        },
        replaceSituation: {
          rules: [{
            required: true,
            message: '请输入部件更换情况!'
          }]
        },
        calibrationTime: {
          rules: [{
            required: true,
            message: '请选择修复后使用前校准时间!'
          }]
        },
        calibrationRes: {
          rules: [{
            required: true,
            message: '请选择校准结果是否合格!'
          }]
        },
        checkRes: {
          rules: [{
            required: true,
            message: '请选择核查结果是否合格'
          }]
        },
        normalTime: {
          rules: [{
            required: true,
            message: '请选择正常投入使用时间'
          }]
        },
        faultLevel: {
          rules: [{
            required: true,
            message: '请选择故障等级'
          }]
        },
        fee: {
          rules: [{
            required: true,
            message: '请输入维修费用'
          }]
        }
      },
      siteName: ''
    };
  },
  props: {
    pagePath: String,
    userTree: Array,
    siteAssetList: Array
  },
  watch: {
    currentSiteId: function currentSiteId(value) {
      this.siteId = value;
    },
    currentSiteName: function currentSiteName(newVal) {
      this.siteName = newVal;
    }
  },
  created: function created() {},
  methods: {
    moment: moment,
    add: function add() {
      this.edit({
        siteId: this.siteId
      }, true);
    },
    edit: function edit(record) {
      var _this = this;

      this.form.resetFields();
      this.model = Object.assign({}, record);
      console.log('model:', this.model);

      if (!this.model.id) {
        this.model.siteName = this.siteName;
      }

      this.visible = true;
      this.$nextTick(function () {
        var that = _this; //debugger

        that.form.setFieldsValue(pick(that.model, that.form_fields)); //时间格式化

        var timeVal = {};
        that.form_fields_time.forEach(function (item, index) {
          timeVal[item] = that.model[item] ? moment(that.model[item]) : null;
        });
        that.form.setFieldsValue(timeVal);

        _this.$refs.iwupload.loadUploadFiles();
      });
    },
    handleOk: function handleOk() {
      var _this2 = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          var formData = Object.assign(that.model, values); //时间格式化

          that.form_fields_time.forEach(function (item, index) {
            formData[item] = formData[item] ? formData[item].format(that.$refs[item]['format']) : null;
          });
          formData = _this2.$refs.iwupload.getUploadListToFromData(formData); //debugger
          //console.log(formData)

          var httpurl = '',
              method = '';

          if (!_this2.model.id) {
            httpurl = _this2.url.add ? _this2.url.add : _this2.pagePath;
            method = 'post';
          } else {
            httpurl = _this2.url.edit ? _this2.url.edit : _this2.pagePath;
            method = 'put';
          }

          httpAction(httpurl, formData, method).then(function (res) {
            if (res.success) {
              _this2.$refs.iwupload.resetUploadFiles();

              that.$notification.success({
                message: res.message
              });
              that.$emit('ok');
              that.close();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    }
  }
};